import React from 'react';
import { useParams } from 'react-router-dom';
import messages from '../displayMessages';
import CategoryHome from './CategoryHome/CategoryHome';
import { CareerStandardLayout } from './CareerStandardLayout';
import CareerHome from './CareerHome/CareerHome';
import { GlobalHeader } from './CareerStandardLayout/GlobalHeader';

const HomePage: React.FC = () => {
  const { pageType } = useParams<{ pageType: 'fields' | 'careers' }>();

  const headerTitle = (() => {
    switch (pageType) {
      case 'fields':
        return messages.exploreFieldsNavOption;
      case 'careers':
        return messages.exploreCareersNavOption;
      default:
        return messages.exploreInvalidNavOption;
    }
  })();

  return (
    <CareerStandardLayout
      mainClassName='career-home-page'
      pageTitle={messages.careerDefaultPageTitle}
      headerComponent={<GlobalHeader heading={headerTitle} />}
    >
      <div className='home-page'>
        {pageType === 'fields' && <CategoryHome />}
        {pageType === 'careers' && <CareerHome />}
      </div>
    </CareerStandardLayout>
  );
};

export default HomePage;
